import { classifyGame } from "./gameStatus";

// Compact score-ticker odds for FUTURE scheduled games only. Truthful or nothing:
// derives the favored side + spread from the real provider snapshot; renders
// nothing when odds are missing, stale, malformed, or provider-unavailable.

function num(v) {
  if (v === null || v === undefined || v === "") return NaN;
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
}
function fmtLine(n) {
  const r = Math.round(n * 10) / 10;
  return String(r);
}

// Parse a `/games/{id}/odds` response (snapshots[]) into "FAV -X.Y" or null.
export function parseTickerSpread(oddsResp, game) {
  const snaps = oddsResp && (Array.isArray(oddsResp.snapshots) ? oddsResp.snapshots
    : Array.isArray(oddsResp.odds) ? oddsResp.odds : null);
  if (!snaps || !snaps.length) return null;
  const snap = snaps.find((s) => s && (s.kind === "current" || s.kind == null)) || snaps[0];
  if (!snap) return null;
  if (snap.data_state && snap.data_state !== "live") return null; // stale / unavailable

  const homeVal = num(snap.spread_home_value != null ? snap.spread_home_value : snap.spread);
  const awayVal = num(snap.spread_away_value);

  let favIsHome, line;
  if (Number.isFinite(homeVal) && Number.isFinite(awayVal)) {
    if (homeVal < 0) { favIsHome = true; line = homeVal; }
    else if (awayVal < 0) { favIsHome = false; line = awayVal; }
    else return null; // pick'em / malformed (no negative side)
  } else if (Number.isFinite(homeVal)) {
    if (homeVal < 0) { favIsHome = true; line = homeVal; }
    else if (homeVal > 0) { favIsHome = false; line = -homeVal; }
    else return null;
  } else {
    return null; // malformed / missing spread
  }

  const favAbbr = favIsHome ? (game && game.home && game.home.abbr) : (game && game.away && game.away.abbr);
  if (!favAbbr) return null;
  return `${favAbbr} ${fmtLine(line)}`;
}

// Only future scheduled games get an odds line; live/final presentation is never
// affected (returns null even if odds happen to be cached for that id).
export function tickerSpreadFor(game, oddsMap, now = Date.now()) {
  if (!game || classifyGame(game, now) !== "upcoming") return null;
  const v = oddsMap && oddsMap[game.id];
  return v || null;
}

// Bounded, deduped odds load for the ticker's future-game slice. Caches by game
// id for the page session so re-renders never refetch the same game.
export async function loadTickerOdds(games, fetchFn, cache) {
  const list = Array.isArray(games) ? games : [];
  await Promise.all(list.map(async (g) => {
    if (!g || !g.id || cache.has(g.id)) return;
    cache.set(g.id, undefined); // reserve id up-front to dedupe concurrent calls
    try {
      const resp = await fetchFn(g.id);
      cache.set(g.id, parseTickerSpread(resp, g));
    } catch (e) {
      cache.set(g.id, null);
    }
  }));
  return cache;
}
